import {
  DiNodejs,
  DiReact,
  DiMongodb,
  DiJava,
  DiGit,
  DiAndroid,
} from "react-icons/di";
import {
  SiExpress,
  SiMysql,
  SiPostgresql,
  SiTailwindcss,
  SiMicrosoftazure,
  SiAmazonaws,
  SiDocker,
  SiJavascript,
  SiTypescript,
  SiPython,
  SiOpenai,
  SiKubernetes,
  SiGooglecloud,
  SiHtml5,
  SiCss3,
  SiMicrosoftsqlserver,
  SiTensorflow,
  SiBootstrap,
} from "react-icons/si";

function Techstack() {
  return (
    <>
      <h3 className="tech-category">Programming Languages & Core Technologies</h3>
      <div className="tech-grid">
        <div className="experience-card tech-card">
          <SiJavascript className="tech-icon" />
          <h3>JavaScript</h3>
          <p>Modern web development with ES6+ features</p>
        </div>
        <div className="experience-card tech-card">
          <SiTypescript className="tech-icon" />
          <h3>TypeScript</h3>
          <p>Type-safe JavaScript development</p>
        </div>
        <div className="experience-card tech-card">
          <DiJava className="tech-icon" />
          <h3>Java</h3>
          <p>Enterprise application development</p>
        </div>
        <div className="experience-card tech-card">
          <SiPython className="tech-icon" />
          <h3>Python</h3>
          <p>Data science and backend development</p>
        </div>
        <div className="experience-card tech-card">
          <SiHtml5 className="tech-icon" />
          <h3>HTML5</h3>
          <p>Modern web markup and semantics</p>
        </div>
        <div className="experience-card tech-card">
          <SiCss3 className="tech-icon" />
          <h3>CSS3</h3>
          <p>Advanced styling and animations</p>
        </div>
      </div>

      <h3 className="tech-category">Web Technologies & Frameworks</h3>
      <div className="tech-grid">
        <div className="experience-card tech-card">
          <DiNodejs className="tech-icon" />
          <h3>Node.js</h3>
          <p>Server-side JavaScript runtime</p>
        </div>
        <div className="experience-card tech-card">
          <DiReact className="tech-icon" />
          <h3>React</h3>
          <p>Modern UI development</p>
        </div>
        <div className="experience-card tech-card">
          <SiExpress className="tech-icon" />
          <h3>Express</h3>
          <p>Web application framework</p>
        </div>
        <div className="experience-card tech-card">
          <SiTailwindcss className="tech-icon" />
          <h3>Tailwind</h3>
          <p>Utility-first CSS framework</p>
        </div>
        <div className="experience-card tech-card">
          <SiBootstrap className="tech-icon" />
          <h3>Bootstrap</h3>
          <p>UI component library</p>
        </div>
        <div className="experience-card tech-card">
          <DiAndroid className="tech-icon" />
          <h3>Android</h3>
          <p>Mobile app development</p>
        </div>
      </div>

      <h3 className="tech-category">Databases</h3>
      <div className="tech-grid">
        <div className="experience-card tech-card">
          <DiMongodb className="tech-icon" />
          <h3>MongoDB</h3>
          <p>NoSQL database</p>
        </div>
        <div className="experience-card tech-card">
          <SiMysql className="tech-icon" />
          <h3>MySQL</h3>
          <p>Relational database</p>
        </div>
        <div className="experience-card tech-card">
          <SiPostgresql className="tech-icon" />
          <h3>PostgreSQL</h3>
          <p>Advanced relational database</p>
        </div>
        <div className="experience-card tech-card">
          <SiMicrosoftsqlserver className="tech-icon" />
          <h3>SQL Server</h3>
          <p>Enterprise database solution</p>
        </div>
      </div>

      <h3 className="tech-category">Cloud & DevOps</h3>
      <div className="tech-grid">
        <div className="experience-card tech-card">
          <SiMicrosoftazure className="tech-icon" />
          <h3>Azure</h3>
          <p>Microsoft cloud platform</p>
        </div>
        <div className="experience-card tech-card">
          <SiAmazonaws className="tech-icon" />
          <h3>AWS</h3>
          <p>Amazon cloud services</p>
        </div>
        <div className="experience-card tech-card">
          <SiGooglecloud className="tech-icon" />
          <h3>GCP</h3>
          <p>Google cloud platform</p>
        </div>
        <div className="experience-card tech-card">
          <SiDocker className="tech-icon" />
          <h3>Docker</h3>
          <p>Container platform</p>
        </div>
        <div className="experience-card tech-card">
          <SiKubernetes className="tech-icon" />
          <h3>Kubernetes</h3>
          <p>Container orchestration</p>
        </div>
        <div className="experience-card tech-card">
          <DiGit className="tech-icon" />
          <h3>Git</h3>
          <p>Version control system</p>
        </div>
      </div>

      <h3 className="tech-category">AI & Machine Learning</h3>
      <div className="tech-grid">
        <div className="experience-card tech-card">
          <SiOpenai className="tech-icon" />
          <h3>OpenAI</h3>
          <p>AI/ML implementation</p>
        </div>
        <div className="experience-card tech-card">
          <SiTensorflow className="tech-icon" />
          <h3>TensorFlow</h3>
          <p>Machine learning framework</p>
        </div>
      </div>
    </>
  );
}

export default Techstack;
